import $ from 'jquery';
import '../vendors/slick';

const $slider = $( '.eb-js-showcase-slider' );
const $counter = $( '.eb-js-showcase-slider-counter' );
const $dots = $( '.eb-js-showcase-slider-dots' );
const $prevArrow = $( '.eb-js-showcase-slider-prev' );
const $nextArrow = $( '.eb-js-showcase-slider-next' );

if( $( "html" ).attr("dir") == "rtl" ) {
	var rtl = true;
} else {
	var rtl = false;
}

$slider.on( 'init reInit afterChange', ( event, slick, currentSlide ) => {
	var i = ( currentSlide ? currentSlide : 0 ) + 1;

	$counter.html(
		'<span><span>' +
		( '0' + i ).slice( -2 ) +
		'</span>/</span>' +
		( '0' + slick.slideCount ).slice( -2 )
	);
} );

$slider.slick( {
	rtl: rtl,
	infinite: false,
	arrows: false,
	appendDots: $dots,
	mobileFirst: true,
	responsive: [
		{
			breakpoint: 769,
			settings: {
				dots: true,
				arrows: true,
				prevArrow: $prevArrow,
				nextArrow: $nextArrow,
			}
		},
	],
} );
